<template>
    <div>
        <span class="text-danger" v-if="comprometimento.status == 1">
            <i
                class="fa fa-minus-circle fa-lg icon-button"
                title="Bloquear"
                @click.stop="confirmar()"
            ></i>
        </span>
        <span class="text-danger" v-if="comprometimento.status == 7">
            <i
                class="fa fa-check-circle fa-lg icon-button"
                title="Desbloquear"
                @click.stop="confirmar()"
            ></i>
        </span>
    </div>
</template>

<script>
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        tipo: {
            type: Number,
            default: () => 0
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            let titulo =
                this.comprometimento.status == 1 ? 'Bloqueio' : 'Desbloqueio'
            let texto =
                this.comprometimento.status == 1 ? 'bloqueio' : 'desbloqueio'
            this.$swal({
                title: titulo,
                html: `Confirma a realização do ${texto} de id ${this.comprometimento.chaveOrigem}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.bloquearDesbloquear()
                }
            })
        },

        bloquearDesbloquear() {
            this.$store.dispatch('addRequest')
            let bloquearDesbloquearDto = {
                idContrato: this.contrato.idContrato,
                idComprometimentoRequisicao: this.comprometimento
                    .idComprometimentoRequisicao
            }
            ComprometimentosServicos.bloquearDesbloquear(
                bloquearDesbloquearDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Operação realizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarComprometimentos', response.data)
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
